import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchTransactionHistory,
  createTransactionHistory,
  updateTransactionHistory,
  slice,
} from '../store/apps/transactionHistory';

export const useTransactionHistory = () => {
  const dispatch = useDispatch();
  const { history, status } = useSelector((state) => state.transactionHistory);

  const fetchForWallet = useCallback((body) => dispatch(fetchTransactionHistory(body)), [dispatch]);

  const create = useCallback(
    (body) => dispatch(createTransactionHistory(body)).unwrap(),
    [dispatch],
  );

  const update = useCallback(
    (id, body) => dispatch(updateTransactionHistory({ id, body })),
    [dispatch],
  );

  const patchStatus = useCallback(
    (payload) => dispatch(slice.actions.patchTransactionStatus(payload)),
    [dispatch],
  );

  const clearAll = useCallback(() => dispatch(slice.actions.clearAll()), [dispatch]);

  const setStatus = useCallback((value) => dispatch(slice.actions.handleStatus(value)), [dispatch]);

  const getTxHistoryByChain = useCallback((chain) => history?.[chain] ?? [], [history]);

  return {
    history,
    status,
    fetchForWallet,
    create,
    update,
    patchStatus,
    clearAll,
    setStatus,
    getTxHistoryByChain,
    actions: slice.actions,
  };
};
